import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cuid from 'cuid';

import {
  TASK_FILE_EXTENSIONS,
  TASK_DOCUMENTS_FORMATS,
  MAX_TASK_ATTACHMENT_SIZE_ALLOWED,
} from '../../../../constants';
import { DocumentView } from '../../../common/DocumentView';
import { UploadDocument } from '../VisitDocuments/UploadDocument';
import { NEW_MESSAGE_ERRORS } from '../../../../constants/chat';

const TASK_DOCUMENTATION_ERRORS = {
  [NEW_MESSAGE_ERRORS.ATTACHMENT_NOT_ALLOWED_FORMAT]:
    'task.error.acceptedFileType',
  [NEW_MESSAGE_ERRORS.ATTACHMENT_MAX_SIZE]: 'task.error.acceptedFileSize',
};

export function TaskDocuments({
  disabled,
  completed,
  attachments,
  addAttachment,
  formatMessage,
}) {
  const [error, setError] = useState(null);

  const handleFileAdd = data => {
    const fileError = get(data, 'fileError');
    if (fileError) {
      const errors = get(data, 'errors');
      setError(TASK_DOCUMENTATION_ERRORS[errors[0]]);
    } else {
      const file = get(data, 'file');
      if (file) {
        setError(null);
        const id = cuid();
        const addedFile = { ...data, id };
        addAttachment([...attachments, addedFile]);
      }
    }
  };

  const handleFileDelete = fileId => {
    setError(null);
    const filtered = attachments.filter(({ id }) => id !== fileId);
    addAttachment(filtered);
  };

  const handleOpenDocument = fileUrl => {
    window.open(fileUrl);
  };

  return (
    <Fragment>
      <If condition={!completed}>
        <UploadDocument
          iconSize={20}
          setAttachment={handleFileAdd}
          handleAddDocument={() => {}}
          titleAddButton={formatMessage({
            id: 'appointment.documents.addDocument.title',
          })}
          allowedFormats={TASK_DOCUMENTS_FORMATS}
          textStyle="f-14 o-100 mb0"
          disabled={disabled}
          maxSize={MAX_TASK_ATTACHMENT_SIZE_ALLOWED}
          validFileExtensions={TASK_FILE_EXTENSIONS}
        />
        <div className="f-12 o-70 mb3">
          {formatMessage({ id: 'task.acceptedFileTypes' })}
        </div>
        {error && (
          <div className="g-color--error mb3">
            {formatMessage({ id: error })}
          </div>
        )}
      </If>
      {attachments &&
        attachments.map(item => {
          const { file, id, name, link } = item || {};
          const fileName = get(file, 'name');
          return (
            <DocumentView
              key={id || link}
              className="f-14"
              accent={completed}
              pointer={completed}
              showButton={!completed}
              title={completed ? name : fileName}
              onDelete={() => handleFileDelete(id)}
              onClick={() => (completed ? handleOpenDocument(link) : {})}
            />
          );
        })}
    </Fragment>
  );
}

TaskDocuments.propTypes = {
  completed: PropTypes.bool,
  disabled: PropTypes.bool,
  attachments: PropTypes.array,
  addAttachment: PropTypes.func,
  formatMessage: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/TaskDetailsPopup/TaskDocuments.jsx